import React, { useEffect } from "react";
import { BUTTON_MUTED, BUTTON_PRIMARY, PANEL_CLASS } from "./uiConstants";

type ConfirmActionModalProps = {
  isOpen: boolean;
  actionLabel: string;
  selectedCount: number;
  remainingSelections: number | null;
  onCancel: () => void;
  onConfirm: () => void;
};

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  actionLabel,
  selectedCount,
  remainingSelections,
  onCancel,
  onConfirm,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (event.target === event.currentTarget) {
      onCancel();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-black/60 px-4 py-8"
      role="dialog"
      aria-modal="true"
      aria-labelledby="confirm-action-modal-title"
      onClick={handleBackdropClick}
    >
      <div className={`${PANEL_CLASS} relative w-full max-w-md p-6 shadow-2xl`}>
        <h2 id="confirm-action-modal-title" className="text-xl font-semibold text-slate-900">
          Confirm Action Submission
        </h2>
        <p className="mt-3 text-sm text-slate-800">
          You are about to submit <strong>{actionLabel}</strong> with{" "}
          <strong>{selectedCount}</strong> selected tile{selectedCount === 1 ? "" : "s"}.
        </p>
        {remainingSelections !== null && (
          <p className="mt-2 text-xs text-slate-700">
            Remaining actions available after submission: {Math.max(0, remainingSelections)}
          </p>
        )}
        <p className="mt-3 text-sm text-slate-800">
          Once submitted, this action will be finalized for the current act. Are you sure you want to continue?
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
          <button type="button" onClick={onCancel} className={BUTTON_MUTED}>
            Go Back
          </button>
          <button type="button" onClick={onConfirm} className={BUTTON_PRIMARY}>
            Submit Action
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;
